export class AbstractSingleValueDirective {
    constructor() {
        this.state = null;
    }
    setValue(value) {
        this.state = value;
        return this;
    }
    getMinimumCspVersion() {
        return 1;
    }
    serialize() {
        if (!this.state) {
            return '';
        }
        return `${this.getDirectiveName()} ${this.state};`;
    }
}
